import { isVsmeMethod } from "@esgt/types"
import { useRating } from "lib/providers/RatingProvider"
import { routes } from "lib/routes"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export const IndexRedirect: React.FC = () => {
  const { method, ratingId } = useRating()
  const navigate = useNavigate()
  const isVsme = isVsmeMethod(method?.name)
  const foundationRoot = routes.rating(ratingId, "foundation")

  useEffect(() => {
    if (method) {
      const destination = isVsme ? `${foundationRoot}/finances/saft` : `${foundationRoot}/company-texts/about-company`
      navigate(destination, { replace: true })
    }
  }, [method, isVsme, navigate, foundationRoot])

  return null
}
